/*
 * @Author: your name
 * @Date: 2020-04-22 10:08:34
 * @LastEditTime: 2020-04-29 18:29:18
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \frontend\modules\@cloudpivot\form\src\components\Dropdown\schema.ts
 */
import { DataType } from "@cloudpivot/form/typings";
import { selectControlOptions } from "@cloudpivot/form/component-schema";
export default {
    $id: "customRichText",
    type: DataType.Object,
    $ref: selectControlOptions.$id,
    properties: {
        options: {
            type: DataType.String,
            title: "选项",
            default: "",
        },
        widgetType: {
            type: DataType.Number,
            title: "控件类型",
        },
        dataItemType: {
            type: DataType.String,
            title: "数据项类型",
        },
        requiredFormula: {
            type: DataType.String,
            title: "是否必填",
        },
    },
};
